export default function About() {
  return (
    <section id="about" className="w-full py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6 max-w-7xl mx-auto">
        <div className="max-w-3xl mx-auto text-center">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-6">
            关于女神漫画
          </h2>
          <div className="space-y-4 text-sm md:text-base text-foreground-700 leading-relaxed">
            <p>
              女神漫画网是专注于免费漫画在线阅读的一站式平台，汇聚海量<strong>韩漫、日漫、国漫</strong>资源，涵盖恋爱、奇幻、悬疑、热血、搞笑、校园等全品类题材。无论你是资深二次元还是刚入坑的漫画萌新，这里都有属于你的阅读角落。
            </p>
            <p>
              平台采用<strong>下拉式在线阅读</strong>模式，无需翻页等待，流畅滚动即可畅享高清画质。站内漫画每日同步更新，热门连载第一时间追踪，更有智能<strong>热门排行榜</strong>与编辑精选推荐，帮你轻松锁定高分神作，告别书荒烦恼。
            </p>
            <p>
              女神漫画始终坚持免费、纯净的阅读理念，无弹窗广告干扰，致力于为漫画爱好者打造舒适、沉浸的阅读体验。我们相信，好的漫画值得被更多人看见。
            </p>
          </div>
          <div className="mt-8 flex flex-wrap items-center justify-center gap-6 md:gap-10">
            <div className="text-center">
              <div className="text-3xl md:text-4xl font-bold text-primary-500 font-heading">5年+</div>
              <div className="text-xs md:text-sm text-foreground-600 mt-1">稳定运营</div>
            </div>
            <div className="text-center">
              <div className="text-3xl md:text-4xl font-bold text-primary-500 font-heading">300万+</div>
              <div className="text-xs md:text-sm text-foreground-600 mt-1">月活读者</div>
            </div>
            <div className="text-center">
              <div className="text-3xl md:text-4xl font-bold text-primary-500 font-heading">99.7%</div>
              <div className="text-xs md:text-sm text-foreground-600 mt-1">好评率</div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}